import React, { useState, useContext, useCallback, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';

import * as S from "./styles"
import AuthContext from "../../context/auth-context";

import { LoadingPage } from "../AuxiliarPages/LoadingPage/LoadingPage";
import { NoAccessPage } from "../AuxiliarPages/NoAccessPage/NoAccessPage";
import { ErrorPage } from "../AuxiliarPages/ErrorPage/ErrorPage";

export const MetricsDashboardPage = () => {
    const navigate = useNavigate();
    const userData = useContext(AuthContext).user_data
    const userRoles = userData.roles;

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({
        hasError: false,
        statusCode: 200,
    });

    const [metabaseChartUrl, setMetabaseChartUrl] = useState("")

    const handleToast = (message, type) => {
        if (type === "success") {
            toast.success(message, {
                position: "top-center",
                autoClose: 2500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light"
            })
        } else if (type === "error") {
            toast.error(message, {
                position: "top-center",
                autoClose: 2500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            })
        } else if (type === 'warning') {
            toast.warning(message, {
                position: "top-right",
                autoClose: 2500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            })
        }
    }

    const requestCompanyMetabaseURL = useCallback(() => {
        setLoading(true)
        const timer = setTimeout(() => {
            axios
                .get(`/dash/metabase_proxy/metabase_chart_url`)
                .then((response) => {
                    if (response.data?.metabase_url) {
                        setMetabaseChartUrl(response.data?.metabase_url)
                    } else {
                        handleToast('Erro ao encontrar dashboard. Contate a equipe de suporte para obter o recurso.', 'warning')
                        setError({
                            has_error: true,
                            status: 404,
                        });
                    }
                })
                .catch((error) => {
                    if ([404].includes((error.response || {}).status)) {
                        setError({
                            has_error: true,
                            status: error.response.status,
                        });
                    } else {
                        setError({
                            has_error: true,
                            status: 500,
                        });
                    }
                    handleToast('Erro ao encontrar dashboard. Contate a equipe de suporte para obter o recurso.', 'error')
                })
                .finally(() => {
                    setLoading(false);
                });
        }, 500);
        return () => {
            clearTimeout(timer);
        };
    }, []);

    useEffect(() => {
        return requestCompanyMetabaseURL();
    }, [requestCompanyMetabaseURL]);

    if (!userRoles.includes("metabase_chart_viewer")) {
        navigate("/envelope-inbox");
    }

    if (!userRoles.includes("metabase_chart_viewer")) {
        return (
            <S.MetricsDashboardPageContainer>
                <NoAccessPage />
            </S.MetricsDashboardPageContainer>
        );
    }
    if (loading) {
        return (
            <S.MetricsDashboardPageContainer>
                <LoadingPage />
            </S.MetricsDashboardPageContainer>
        );
    } else if (error.hasError) {
        return (
            <S.MetricsDashboardPageContainer>
                <ErrorPage />
            </S.MetricsDashboardPageContainer>
        );
    } else if (metabaseChartUrl.length > 0) {
        return (
            <>
                <ToastContainer
                    position="top-center"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                />
                { userRoles.includes("metabase_chart_viewer") &&
                    <div className="page-container">
                        <header>
                            <h1>Métricas de assinatura</h1>
                        </header>
                        <S.IframeContainer>
                            <iframe
                                src={metabaseChartUrl}
                                title="Dashboard de Métricas"
                                width="100%"
                                height="100%"
                                style={{ border: 'none', minHeight: '90vh' }}
                                allowFullScreen
                            />
                        </S.IframeContainer>
                    </div>
                }
            </>
        )
    } else {
        return (
            <S.MetricsDashboardPageContainer>
                <ErrorPage />
            </S.MetricsDashboardPageContainer>
        );
    }
}